import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'sera-items-count',
    templateUrl: './sera-items-count.component.html',
    styleUrls: ['./sera-items-count.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class SeraItemsCountComponent {
    @Input()
    showCount: boolean = false;

    @Input()
    itemsCount: number | undefined | null = 0;

    @Input()
    loading: boolean | null = false;

    @Input()
    styleClass: string | null = null;
}
